import UserCourseStat from "../../../../models/UserCourseStat";

export function getUserId(stat: UserCourseStat) {
  return stat.userId;
}

export function getCourseId(stat: UserCourseStat) {
  return stat.courseId;
}
